const formatTrackAddressToId = (track: string): string => {
  try {
    let newTrack = '';
    track.trim();
    if (track.startsWith('https')) {
      newTrack = parseSpotifyUrl(track);
    } else if (track.startsWith('spotify:track:')) {
      newTrack = cleanSpotifyUri(track);
    } else {
      throw new TypeError(
        'Track ID does not start with "https" or "spotify:track:"',
      );
    }
    return newTrack;
  } catch (e) {
    console.error((<Error>e).message);
    return '';
  }
};

//TODO: Clean this function since songIDs will be inputed as URIs (e.g. spotify:track:<trackId>)
const cleanSpotifyUri = (songId) => {
  let splittedArray = songId.split(':');
  return splittedArray[2];
};

const capitalizeFirstLetter = (text) => {
  const capText = text.charAt(0).toUpperCase() + text.slice(1);
  return capText;
};

const updateToUri = (songId) => {
  let newSongId = '';
  if (songId.startsWith('spotify:track:')) {
    return songId;
  } else if (songId.startsWith('https')) {
    newSongId = parseSpotifyUrl(songId);
    return newSongId && 'spotify:track:' + newSongId;
  }
  return 'spotify:track:' + songId;
};

const parseSpotifyUrl = (address) => {
  let regStr = 'track/([\\S\\d]{22})';
  let regexp = new RegExp(regStr);
  let regExpReturn = address.match(regexp);
  let split = regExpReturn && regExpReturn[0].split('/');
  return split && split[1];
};

export default {
  formatTrackAddressToId,
  cleanSpotifyUri,
  capitalizeFirstLetter,
  updateToUri,
  parseSpotifyUrl,
};
